export default "__VITE_ASSET__utkEIxUZ__"